"use client";
import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { SelectRoot as i, SelectTrigger as m, SelectValue as u } from "../../atoms/Select/Select.mjs";
import { cn as k } from "../../../utils/utils.mjs";
const S = ({
  className: e,
  children: t,
  iconPrefix: a,
  iconSuffix: l,
  placeholder: n,
  selectTriggerProps: o,
  selectValueProps: c,
  ...d
}) => /* @__PURE__ */ s(i, { ...d, children: [
  /* @__PURE__ */ r(
    m,
    {
      iconPrefix: a,
      iconSuffix: l,
      className: k(
        "min-w-38 p-4 rounded-sm dark:bg-neutral-dark-200 dark:hover:bg-neutral-dark-400 dark:text-neutral-dark-1000",
        e
      ),
      ...o,
      children: /* @__PURE__ */ r(u, { placeholder: n, ...c })
    }
  ),
  t
] });
export {
  S as SelectInput
};
